import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { get } from 'lodash-es';

import { RelatedVideoTitle } from './related-video-title';
import { DurationMask } from 'components/video-item/masks';
import { VideoPlaceholder } from 'components/video-player/video-placeholder';
import { VideoItemAdditionalMetadata } from 'components/video-item/video-item-additional-metadata';
import { times } from 'lodash-es';

export const RelatedVideoItemPlaceholder = () => {
  const numberOfPlaceholders = 6;

  return times(numberOfPlaceholders).map((el) => (
    <div className="ct-related-video" key={el}>
      <VideoPlaceholder horizontal />
    </div>
  ));
};

export const RelatedVideoItem = (props) => {
  const { video, url } = props;
  const goToLink = url + '#top';

  return (
    <div className="ct-related-video" data-e2e={`video-item-${video.id}`}>
      <Link to={goToLink}>
        <div
          className="ct-related-video__thumbnail"
          style={get(video, 'thumbnail.url') && { backgroundImage: `url(${video.thumbnail.url})` }}
        >
          <DurationMask duration={video.length} />
        </div>
      </Link>

      <div className="ct-related-video__metadata">
        <RelatedVideoTitle url={goToLink} title={video.title} />
        <VideoItemAdditionalMetadata video={video} breakLineBeforeRating={true} />
      </div>

      <div className="ct-related-video__title">
        <RelatedVideoTitle url={goToLink} title={video.title} />
      </div>
    </div>
  );
};

RelatedVideoItem.propTypes = {
  video: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
};
